import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { BreadcrumbService } from './breadcrumb.service';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@jsverse/transloco';
import { toSignal } from '@angular/core/rxjs-interop';
import { PROJECT_NAME } from '../../app.constants';

@Component({
  selector: 'app-breadcrumbs',
  imports: [RouterLink, MatIconModule, TranslocoModule, MatIcon],
  styleUrl: './breadcrumbs.component.scss',
  template: `@let crumbs = crumbsState();
    <ng-container *transloco="let t">
      <nav>
        <a class="logo" routerLink="/">
          <mat-icon svgIcon="head-snowflake-outline" />
          <span class="underline-on-hover">{{ title }}</span>
        </a>
        @for (crumb of crumbs.slice(0, -1); track $index) {
          <span> / </span>
          <a class="underline-on-hover" [routerLink]="crumb.url">
            {{ crumb.raw ? crumb.label : t(crumb.label) }}
          </a>
        }
      </nav>
    </ng-container>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbsComponent {
  private readonly breadcrumbService = inject(BreadcrumbService);
  protected readonly crumbsState = toSignal(this.breadcrumbService.getBreadcrumbs$(), {
    initialValue: [],
  });

  protected readonly title = PROJECT_NAME;
}
